import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const twoFaEnabledDateState = atom({
  key: "twoFaEnabledDateState",
  default: null,
  effects_UNSTABLE: [ocPersistAtom],
});
